module.exports = __webpack_public_path__ + "img/img_crown_hover.5f788869.svg";